/** Fixed datasets owned by Retail Location Micro Store. */
export enum RetailLocationMicroStoreWorkspaceCapabilityUdoTemplateKey {
    microStore = "95ef68e9-914e-43b4-97c2-184170c278f9",
    page = "a2e565bf-d0b0-4d57-992a-ad1c958a9054",
    defaultPage = "d53c8cfb-0a92-4031-bf3d-4cc90feb737e",
}
